// api
import { fetchApi } from '@/api'
// actions
const academicCoursesAll = (context) => {
  let url = 'academic/courses'
  return fetchApi(url, [], 'GET')
    .then((response) => {
      context.commit('ACADEMIC_COURSES_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const academicCoursesFrom = (context, data) => {
  let url = 'academic/courses/create'
  return fetchApi(url, {}, 'GET')
    .then((response) => {
      context.commit('ACADEMIC_COURSES_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const academicCoursesSelect = (context) => {
  let url = 'academic/courses/all'
  return fetchApi(url, {}, 'GET')
    .then((response) => {
      context.commit('ACADEMIC_COURSES_ALL', response)
    })
    .catch((error) => {
      console.error(error)
    })
}

const academicCoursesStudents = (context,data) => {
  let url = 'academic/courses/students'
  let Json = JSON.stringify(data)
  return fetchApi(url, Json, 'POST')
    .then((response) => {
      context.commit('ACADEMIC_COURSES_ALL', response)
    })
    .catch((error) => {
      console.error(error)
    })
}

const academicCoursesCreate = (context, data) => {
  let Json = JSON.stringify(data)
  let url = 'academic/courses'
  return fetchApi(url, Json, 'POST')
    .then((response) => {
      context.commit('ACADEMIC_COURSES_ALL', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const academicCoursesEdit = (context, data) => {
  let obj = JSON.parse(data)
  let url = 'academic/courses/' + obj.id + '/edit'
  return fetchApi(url, {}, 'GET')
    .then((response) => {
      context.commit('ACADEMIC_COURSES_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const academicCoursesUpdate = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'academic/courses/' + obj.id
  return fetchApi(url, payload, 'PUT')
    .then((response) => {
      context.commit('ACADEMIC_COURSES_ALL', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

export default {
  academicCoursesAll,
  academicCoursesSelect,
  academicCoursesStudents,
  academicCoursesCreate,
  academicCoursesEdit,
  academicCoursesUpdate,
  academicCoursesFrom
}



// WEBPACK FOOTER //
// ./src/store/modules/academic/courses/actions.js